// extracted by mini-css-extract-plugin
export var canvas = "_7-1";
export var container = "_7-0";
export var fallback = "_7-2";